<template>
    <BuyRecognitionComponent/>
</template>

<script>
import BuyRecognitionComponent from "@/views/recognition/pages/buy_recognition/components/buy_recognition_component.vue"
export default {
    name: "buyRecognition",
    components: {
        BuyRecognitionComponent
    },
}
</script>

<style lang="css" scoped>
</style>